import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AppCommon } from '../../providers/app-common';
import { ClientViewModel } from '../../models-views/client.view.model';
import { QuickAddService } from '../../services/quick-add.service';

@Component({
  selector: 'app-client-add-poc',
  standalone: false,
  templateUrl: './client-add-poc.component.html',
  styleUrl: './client-add-poc.component.scss'
})
export class ClientAddPocComponent {

  @Input() data: any;
  @Input() clientID: any;
  @Input() isVisible = false;
  @Input() allPOCData: any[] = [];
  @Output() closeDrawer = new EventEmitter<boolean>();
  @Output() closeDrawerData = new EventEmitter<boolean>();
  contactForm: FormGroup;
  loggedInUser: any
  countryCodeList:any = []
  regionList:any = []
  verticalList:any = []
  regionSearchTimeOut:any
  verticalSearchTimeOut:any

  constructor(private fb: FormBuilder, private message: NzMessageService, private vmc: ClientViewModel,
    private quickAddService: QuickAddService,private cdRef: ChangeDetectorRef
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user
    this.vmc.clientAddPocComponent = this
      this.contactForm = this.fb.group({
      poc_name: ['', [Validators.required]],
      job_title: [''],
      region: [null],
      vertical: [null],
      poc_email: ['', [Validators.required, Validators.email]],
      poc_phone: ['', [Validators.required]],
      country_code: ['', [Validators.required]],
      poc_linkedin: ['']
    });

    this.vmc.getCountryCodeList()
    this.vmc.countryCodeList.subscribe(data => { this.countryCodeList = data.results  })
    this.vmc.regionList.subscribe(data => { this.regionList = data?.results || [] })
    this.vmc.verticalList.subscribe(data => { this.verticalList = data?.results || [] })
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    console.log(changes['data']?.currentValue)
    console.log(changes['isVisible']?.currentValue)
    
    // Handle modal visibility change
    if (changes['isVisible']) {
      if (changes['isVisible'].currentValue === true) {
        this.vmc.getRegionList();
        this.vmc.getVerticalList();
      }
      if (changes['isVisible'].currentValue === true && !this.data) {
        // Modal is opening in "add new" mode (no data)
        this.contactForm.reset();
        this.cdRef.markForCheck();
      }
    }
    
    // Handle data change for edit mode
    if (changes['data']?.currentValue && this.data) {
      let formData = {
        poc_name: changes['data'].currentValue.poc_name,
        job_title: changes['data'].currentValue.job_title,
        region: changes['data'].currentValue.region ?? changes['data'].currentValue.region_id ?? null,
        vertical: changes['data'].currentValue.vertical ?? changes['data'].currentValue.vertical_id ?? null,
        poc_email: changes['data'].currentValue.poc_email,
        poc_phone: changes['data'].currentValue.poc_phone,
        country_code: changes['data'].currentValue.country_code,
        poc_linkedin: changes['data'].currentValue.poc_linkedin
      }
      this.contactForm.patchValue(formData)
    } else if (changes['data'] && !changes['data'].currentValue) {
      // Reset form when switching to "add new" mode (data is undefined)
      this.contactForm.reset();
      this.cdRef.markForCheck();
    }
  }


  handleCancel(): void {
    // console.log('Button cancel clicked!');
    this.isVisible = false;
    this.contactForm.reset();
    this.closeDrawer.emit(false);
    this.quickAddService.refreshData.next(true);
  }

  closeOnly(){
    this.isVisible = false;
    this.contactForm.reset();
    this.closeDrawer.emit(false);
  }

  onSearchRegion(value: string) {
    clearTimeout(this.regionSearchTimeOut);
    this.regionSearchTimeOut = setTimeout(() => {
      this.vmc.getRegionList((value || '').trim());
    }, 400);
  }

  onSearchVertical(value: string) {
    clearTimeout(this.verticalSearchTimeOut);
    this.verticalSearchTimeOut = setTimeout(() => {
      this.vmc.getVerticalList((value || '').trim());
    }, 400);
  }


  save(): void {
    if (this.contactForm.invalid) {
      this.message.error('Please fill all required fields correctly');
      return;
    }

    const formData = { ...this.contactForm.value };
    if (this.data && this.data.id != null) {
      formData.modified_by = this.loggedInUser.id;
      formData.client_poc = this.clientID;
      this.vmc.updatePOC(formData, this.data.id,'add-poc');
    } else if(this.clientID) {
      formData.created_by = this.loggedInUser.id;
      formData.client_poc = this.clientID;
      if (!this.allPOCData.some(el => el.type === 1)) {
        formData.type = 1;
      }
      this.vmc.createPOC(formData,'add-poc');
    } else{
      this.closeDrawerData.emit(this.contactForm.value)
    }
  }


  pocUpdated(){
    if(this.data){
       let d = this.contactForm.value
      d['id'] = this.data.id
      this.closeDrawerData.emit(d)
    }
    // this.isVisible = false;
    this.contactForm.reset();
    this.closeDrawer.emit(true);
  }

  pocCreated(e) {
    
    this.closeDrawer.emit(true);
    this.isVisible = false;
    let d = this.contactForm.value
    d['id'] = e?.id || null
    this.closeDrawerData.emit(d)
    this.contactForm.reset();
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
    // console.log(e , this.isVisible , d)
  }

}

